import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { Tabs } from 'antd'
import AppLayout from 'components/layout/layout'
import Spinner from 'components/Spinner'
import { useGetTeamById } from 'api/Team/Team'
import { teamStore } from 'state/team/team'
import { myStore } from 'state/store'
import TeamProfileHeader from './Header/TeamProfileHeader'
import DetailsTab from './Tabs/DetailsTab'
import MembersTab from './Tabs/MembersTab'
import ManageTeamLead from './Modals/ManageTeamLead'
import ManageCoach from './Modals/ManageCoach'
import ManageMember from './Modals/ManageMember'
import CreateTeam from 'pages/Teams/Modals/CreateTeam'

const { TabPane } = Tabs

const TeamProfile: React.FC = () => {
  const { teamId }: any = useParams()

  const { data: team, isLoading, isFetching, refetch } = useGetTeamById(teamId)

  const {
    teamLeadModalVisible,
    coachModalVisible,
    memberModalVisible,
    teamModalVisible,
    setTeamData,
    setIsUpdatingTeam,
    setTeamModalVisible,
  } = teamStore(store => ({
    teamLeadModalVisible: store.teamLeadModalVisible,
    coachModalVisible: store.coachModalVisible,
    memberModalVisible: store.memberModalVisible,
    teamModalVisible: store.teamModalVisible,
    setTeamData: store.setTeamData,
    setIsUpdatingTeam: store.setIsUpdatingTeam,
    setTeamModalVisible: store.setTeamModalVisible,
  }))

  const setCrumbs = myStore(store => store.setCrumbs)

  useEffect(() => {
    refetch()
  }, [teamId])

  useEffect(() => {
    if (team) setCrumbs(team.name)
  }, [team])

  const handleEditTeam = () => {
    setTeamData(team)
    setIsUpdatingTeam(true)
    setTeamModalVisible(true)
  }

  const organizationId = team?.organizationId ?? ''

  return (
    <AppLayout id={teamId}>
      {isLoading || isFetching ? (
        <Spinner />
      ) : team ? (
        <div className="bg-grey">
          <TeamProfileHeader team={team} onEdit={handleEditTeam} />
          <Tabs
            defaultActiveKey="details"
            className="bg-white profile-tabs"
            style={{ width: '100%' }}
          >
            <TabPane tab="DETAILS" key="details">
              <DetailsTab team={team} />
            </TabPane>
            <TabPane tab="MEMBERS" key="members">
              <MembersTab teamId={teamId} />
            </TabPane>
          </Tabs>
        </div>
      ) : null}

      {teamLeadModalVisible && (
        <ManageTeamLead teamId={teamId} organizationId={organizationId} refetch={refetch} />
      )}
      {coachModalVisible && (
        <ManageCoach teamId={teamId} organizationId={organizationId} refetch={refetch} />
      )}
      {memberModalVisible && (
        <ManageMember teamId={teamId} organizationId={organizationId} refetch={refetch} />
      )}
      {teamModalVisible && <CreateTeam />}
    </AppLayout>
  )
}

export default TeamProfile
